/**
 * 获取头部导航信息
 */
import { config } from 'config'
import 'babel-polyfill'
import { Base64 } from 'js-base64'

function getHeaderNavInfo () {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/wuhu-cms/platform/common?platform=wuhu',
      type: 'get',
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

function showLoginModal () {
  // 跳转到统一登录
  window.location.href = `${config.PASSPORT_NEW}login?jump=${Base64.encode(window.location.href)}`
}

function showRegisterModal () {
  window.location.href = `${config.PASSPORT_NEW}register?jump=${Base64.encode(window.location.href)}`
}

var login = document.getElementsByClassName('quick-login')[0]
login.onclick = function () {
  showLoginModal()
}

var register = document.getElementsByClassName('register')[0]
register.onclick = function () {
  showRegisterModal()
}

export {
  getHeaderNavInfo
}



// WEBPACK FOOTER //
// ./src/js/api/header.js